/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeviceTypeResponse,
    DeviceTypeResponseFromJSON,
    DeviceTypeResponseFromJSONTyped,
    DeviceTypeResponseToJSON,
} from './DeviceTypeResponse';
import {
    DevicesByDeviceTypeResponse,
    DevicesByDeviceTypeResponseFromJSON,
    DevicesByDeviceTypeResponseFromJSONTyped,
    DevicesByDeviceTypeResponseToJSON,
} from './DevicesByDeviceTypeResponse';
import {
    FirmwaresByDeviceTypeResponse,
    FirmwaresByDeviceTypeResponseFromJSON,
    FirmwaresByDeviceTypeResponseFromJSONTyped,
    FirmwaresByDeviceTypeResponseToJSON,
} from './FirmwaresByDeviceTypeResponse';
import {
    ProvisioningDevicesByDeviceTypeResponse,
    ProvisioningDevicesByDeviceTypeResponseFromJSON,
    ProvisioningDevicesByDeviceTypeResponseFromJSONTyped,
    ProvisioningDevicesByDeviceTypeResponseToJSON,
} from './ProvisioningDevicesByDeviceTypeResponse';
import {
    RescueByDeviceTypeResponse,
    RescueByDeviceTypeResponseFromJSON,
    RescueByDeviceTypeResponseFromJSONTyped,
    RescueByDeviceTypeResponseToJSON,
} from './RescueByDeviceTypeResponse';
import {
    StbGroupsByDeviceTypeResponse,
    StbGroupsByDeviceTypeResponseFromJSON,
    StbGroupsByDeviceTypeResponseFromJSONTyped,
    StbGroupsByDeviceTypeResponseToJSON,
} from './StbGroupsByDeviceTypeResponse';
import {
    UpgradeRulesByDeviceTypeResponse,
    UpgradeRulesByDeviceTypeResponseFromJSON,
    UpgradeRulesByDeviceTypeResponseFromJSONTyped,
    UpgradeRulesByDeviceTypeResponseToJSON,
} from './UpgradeRulesByDeviceTypeResponse';

/**
 * 
 * @export
 * @interface DeviceTypeRelationEntitiesResponse
 */
export interface DeviceTypeRelationEntitiesResponse {
    /**
     * 
     * @type {DeviceTypeResponse}
     * @memberof DeviceTypeRelationEntitiesResponse
     */
    deviceType?: DeviceTypeResponse;
    /**
     * 
     * @type {DevicesByDeviceTypeResponse}
     * @memberof DeviceTypeRelationEntitiesResponse
     */
    devices?: DevicesByDeviceTypeResponse;
    /**
     * 
     * @type {ProvisioningDevicesByDeviceTypeResponse}
     * @memberof DeviceTypeRelationEntitiesResponse
     */
    provisioningDevices?: ProvisioningDevicesByDeviceTypeResponse;
    /**
     * 
     * @type {StbGroupsByDeviceTypeResponse}
     * @memberof DeviceTypeRelationEntitiesResponse
     */
    stbGroups?: StbGroupsByDeviceTypeResponse;
    /**
     * 
     * @type {UpgradeRulesByDeviceTypeResponse}
     * @memberof DeviceTypeRelationEntitiesResponse
     */
    upgradeRules?: UpgradeRulesByDeviceTypeResponse;
    /**
     * 
     * @type {FirmwaresByDeviceTypeResponse}
     * @memberof DeviceTypeRelationEntitiesResponse
     */
    firmwares?: FirmwaresByDeviceTypeResponse;
    /**
     * 
     * @type {RescueByDeviceTypeResponse}
     * @memberof DeviceTypeRelationEntitiesResponse
     */
    rescue?: RescueByDeviceTypeResponse;
}

export function DeviceTypeRelationEntitiesResponseFromJSON(json: any): DeviceTypeRelationEntitiesResponse {
    return DeviceTypeRelationEntitiesResponseFromJSONTyped(json, false);
}

export function DeviceTypeRelationEntitiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceTypeRelationEntitiesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceType': !exists(json, 'deviceType') ? undefined : DeviceTypeResponseFromJSON(json['deviceType']),
        'devices': !exists(json, 'devices') ? undefined : DevicesByDeviceTypeResponseFromJSON(json['devices']),
        'provisioningDevices': !exists(json, 'provisioningDevices') ? undefined : ProvisioningDevicesByDeviceTypeResponseFromJSON(json['provisioningDevices']),
        'stbGroups': !exists(json, 'stbGroups') ? undefined : StbGroupsByDeviceTypeResponseFromJSON(json['stbGroups']),
        'upgradeRules': !exists(json, 'upgradeRules') ? undefined : UpgradeRulesByDeviceTypeResponseFromJSON(json['upgradeRules']),
        'firmwares': !exists(json, 'firmwares') ? undefined : FirmwaresByDeviceTypeResponseFromJSON(json['firmwares']),
        'rescue': !exists(json, 'rescue') ? undefined : RescueByDeviceTypeResponseFromJSON(json['rescue']),
    };
}

export function DeviceTypeRelationEntitiesResponseToJSON(value?: DeviceTypeRelationEntitiesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceType': DeviceTypeResponseToJSON(value.deviceType),
        'devices': DevicesByDeviceTypeResponseToJSON(value.devices),
        'provisioningDevices': ProvisioningDevicesByDeviceTypeResponseToJSON(value.provisioningDevices),
        'stbGroups': StbGroupsByDeviceTypeResponseToJSON(value.stbGroups),
        'upgradeRules': UpgradeRulesByDeviceTypeResponseToJSON(value.upgradeRules),
        'firmwares': FirmwaresByDeviceTypeResponseToJSON(value.firmwares),
        'rescue': RescueByDeviceTypeResponseToJSON(value.rescue),
    };
}

